<template>
  <or-teleport>
    <div data-component="base-tabs-mobile-popup">
      <div class="header">
        <or-button
          is-text
          data-button="close"
          color="neutral-6"
          @click="$emit('close-click')"
        >
          <or-icon icon="close" />
        </or-button>
        <div class="header-title">
          {{ $t('hitl.modules.settings.session-views.title') }}
        </div>
      </div>

      <div class="main">
        <a
          v-for="({ value, label }) in menuItems"
          :key="value"
          :data-item="value"
          :class="{ active: activeItemId === value }"
          @click="$emit('item-click', value)"
        >
          {{ label }}
        </a>
      </div>
    </div>
  </or-teleport>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api';
import {
  OrButtonV3 as OrButton,
  OrIconV3 as OrIcon,
  OrTeleportV3 as OrTeleport,
} from '@onereach/ui-components-25';
import { BaseTabItem } from '../../types';

export default defineComponent({
  name: 'SessionsTimelineHeaderTagsMobileContent',
  components: {
    OrButton,
    OrIcon,
    OrTeleport,
  },
  props: {
    menuItems: {
      type: Array as PropType<BaseTabItem[]>,
      default: () => [],
    },
    activeItemId: {
      type: String,
      default: '',
    },
  },
  emits: ['close-click', 'item-click'],
});
</script>

<style lang="scss" scoped>
@use '@/styles' as *;

[data-component] {
  display: none;

  @include max-md {
    display: flex;
  }

  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 50;
  background: var(--or-c-on-primary);

  .header {
    display: flex;
    gap: var(--s-4);
    padding: var(--s-4) var(--s-5);
    background: var(--c-neutral-6);

    &-title {
      color: var(--or-c-on-primary);
      font-size: 1.25rem;
      font-weight: var(--fw-1);
    }

    ::v-deep .or-icon-v3 {
      color: var(--c-neutral-3);
    }
  }

  .main {
    padding: var(--s-4) var(--s-4);
    overflow-x: hidden;
    overflow-y: auto;

    [data-item] {
      @include text-overflow();

      display: block;
      padding: var(--s-3);
      color: var(--or-c-outline);
      cursor: pointer;

      &:hover {
        &:not(.active) {
          background: var(--or-c-primary-opacity-0-08);
        }
      }

      &:not(:first-child) {
        margin-top: var(--s-3);
      }

      &.active {
        color: var(--or-c-on-surface);
        font-size: 1rem;
        font-weight: var(--fw-1);
        cursor: default;
      }
    }
  }
}
</style>
